/* eslint-disable react/jsx-filename-extension */
import { push } from "connected-react-router";
import { actions as debinActions } from "reducers/debin";
import { actions as accountsActions } from "reducers/accounts";

export default function specialOptions(debin, environmentCuit, functionAction) {
    let contextSpecialMenuActions = [];

    switch (debin.status.toUpperCase()) {
        case "INICIADO": {
            contextSpecialMenuActions = [
                {
                    label: `pay.debin`,
                    onClick: () => functionAction("PAY", debin),
                },
                {
                    label: `reject.debin`,
                    onClick: () => functionAction("REJECT", debin),
                },
            ];
            break;
        }
        case "ACTIVA": {
            contextSpecialMenuActions = [
                {
                    label: `pause.debin`,
                    onClick: () => functionAction("PAUSAR", debin),
                },
                {
                    label: `eliminate.debin`,
                    onClick: () => functionAction("ELIMINAR", debin),
                },
            ];
            break;
        }
        case "INACTIVA": {
            contextSpecialMenuActions = [
                {
                    label: `activate.debin`,
                    onClick: () => functionAction("ACTIVAR", debin),
                },
                {
                    label: `eliminate.debin`,
                    onClick: () => functionAction("ELIMINAR", debin),
                },
            ];
            break;
        }
        case "PENDIENTE": {
            contextSpecialMenuActions = [
                {
                    label: `accept.debin`,
                    onClick: () => functionAction("ACCEPT_SCHEDULED", debin),
                },
                {
                    label: `reject.debin`,
                    onClick: () => functionAction("REJECT_SCHEDULED", debin),
                },
            ];
            break;
        }
        case "ACTIVO": {
            contextSpecialMenuActions = [
                {
                    label: `pause.debin`,
                    onClick: () => functionAction("PAUSE_SCHEDULED", debin),
                },
                {
                    label: `cancel.debin`,
                    onClick: () => functionAction("CANCEL_SCHEDULED", debin),
                },
            ];
            break;
        }
        case "INACTIVO": {
            contextSpecialMenuActions = [
                {
                    label: `activate.debin`,
                    onClick: () => functionAction("ACTIVATE_SCHEDULED", debin),
                },
                {
                    label: `cancel.debin`,
                    onClick: () => functionAction("CANCEL_SCHEDULED", debin),
                },
            ];
            break;
        }
        default: {
            break;
        }
    }

    return contextSpecialMenuActions;
}

export const receivedDebinAction = (action, debin, dispatch) => {
    if (action === "PAUSAR" || action === "ELIMINAR" || action === "ACTIVAR") {
        dispatch(debinActions.debinSeller(debin?.seller?.documentNumber));
        dispatch(debinActions.setRecurrencyDebinAction({ action, debin }));
    }

    if (action === "PAY" || action === "REJECT") {
        dispatch(debinActions.acceptIncomingRequestPre(debin.id));
        dispatch(accountsActions.listAccountsCbu());
    }

    if (
        action === "ACCEPT_SCHEDULED" ||
        action === "REJECT_SCHEDULED" ||
        action === "PAUSE_SCHEDULED" ||
        action === "CANCEL_SCHEDULED" ||
        action === "ACTIVATE_SCHEDULED"
    ) {
        dispatch(debinActions.setScheduledDebin(debin));
    }

    switch (action) {
        case "PAY": {
            dispatch(push("/debinPayments/action/received"));
            break;
        }
        case "REJECT": {
            dispatch(push("/debinPayments/action/reject"));
            break;
        }
        case "PAUSAR": {
            dispatch(push("/debinPayments/action/action"));
            break;
        }
        case "ELIMINAR": {
            dispatch(push("/debinPayments/action/action"));
            break;
        }
        case "ACTIVAR": {
            dispatch(push("/debinPayments/action/action"));
            break;
        }
        case "ACCEPT_SCHEDULED": {
            dispatch(push(`/scheduledDebin/action/${"accept"}`));
            break;
        }
        case "REJECT_SCHEDULED": {
            dispatch(push(`/scheduledDebin/action/${"reject"}`));
            break;
        }
        case "PAUSE_SCHEDULED": {
            dispatch(push(`/scheduledDebin/action/${"pause"}`));
            break;
        }
        case "CANCEL_SCHEDULED": {
            dispatch(push(`/scheduledDebin/action/${"cancel"}`));
            break;
        }
        case "ACTIVATE_SCHEDULED": {
            dispatch(push(`/scheduledDebin/action/${"activate"}`));
            break;
        }
        default:
            break;
    }
};
